import { Box, Flex } from "rebass/styled-components";
import styled from "styled-components";

export const ModalContainer = styled(Box)`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 101;
  overflow: hidden;
  overflow-x: hidden;
  overflow-y: auto;
  /* Navy rather than flat black, so the page reads through the scrim. */
  background: ${({ theme }) => theme.colors.midnightAlpha80};
  backdrop-filter: blur(6px);
`;

export const ModalDialog = styled(Flex)`
  position: relative;
  width: auto;
  margin: 24px auto;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: calc(100% - 48px);

  pointer-events: none;
  > * {
    pointer-events: auto;
  }

  max-width: 95%;
`;
